import { render, staticRenderFns } from "./AdditionalGridCollectionInputContainer.vue?vue&type=template&id=c8c6fb1a&scoped=true"
import script from "./AdditionalGridCollectionInputContainer.vue?vue&type=script&lang=js"
export * from "./AdditionalGridCollectionInputContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c6fb1a",
  null
  
)

export default component.exports